const LoadingDots = () => {
  return (
    <div className="relative flex flex-row gap-x-[3px]">
      <div className="w-2 h-2 bg-white rounded-full animate-[pulse_1s_ease-in-out_infinite]" />
      <div className="w-2 h-2 delay-150 bg-white rounded-full animate-[pulse_1s_ease-in-out_infinite]" />
      <div className="w-2 h-2 bg-white delay-300 rounded-full animate-[pulse_1s_ease-in-out_infinite]" />
    </div>
  );
};

export default LoadingDots;
